/**
 * This code is tested in load video test code
 */
import log from "loglevel";
import { delay } from "./promises";
export class VideoLoader {
    constructor(videoEl, src, progressCallback) {
        this.loaded = false;
        this.onProgress = this.onProgress.bind(this);
        this.videoEl = videoEl;
        this.src = src;
        this.progressCallback = progressCallback;
    }
    async _waitVideoElReady() {
        return new Promise((resolve) => {
            $(this.videoEl).ready(resolve);
        });
    }
    async load() {
        log.debug(String(this.videoEl));
        // this.videoEl.src = this.src + "?" + Math.random();
        for (const src of this.src) {
            let type;
            if (src.indexOf("webm") !== -1) {
                type = `video/webm; codecs="vp8"`;
            }
            else {
                type = "video/mp4";
            }
            $(this.videoEl).append($(`<source src="${src}" type="${type}">`));
        }
        const canplaythroughPromise = this.onCanplaythroughPromise();
        // this.videoEl.src = this.src;
        this.videoEl.load();
        // await this._waitVideoElReady();
        log.debug(String(`${this.src} readystate ${this.videoEl.readyState}`));
        if (this.videoEl.readyState === 4) {
            return;
        }
        this.videoEl.addEventListener("progress", this.onProgress, false);
        if (this.videoEl.buffered.length > 0) {
            log.debug(`${this.src} ${this.videoEl.buffered.end(0)} ${this.videoEl.duration}`);
            if (this.videoEl.buffered.end(0) === this.videoEl.duration) {
                return;
            }
        }
        const checkBufferedAgainPromise = this.checkBufferedAgain();
        await Promise.race([
            canplaythroughPromise,
            checkBufferedAgainPromise,
            delay(10000),
        ]);
        this.videoEl.removeEventListener("progress", this.onProgress);
        this.loaded = true;
    }
    onProgress() {
        if (this.videoEl.buffered.length > 0) {
            log.debug(`${this.src} ${this.videoEl.buffered.end(0)} ${this.videoEl.duration}`);
            if (this.progressCallback) {
                if (isNaN(this.videoEl.duration)) {
                    return;
                }
                this.progressCallback({
                    loaded: this.videoEl.buffered.end(0) / this.videoEl.duration,
                });
            }
        }
        else {
            log.debug(String(`${this.src} buffered.length === 0`));
        }
    }
    async onCanplaythroughPromise() {
        return new Promise((resolve) => {
            this.videoEl.addEventListener("canplaythrough", () => {
                this.progressCallback({
                    canplay: true,
                });
                log.debug(String(this.src + " Canplaythrough event"));
                resolve();
            }, false);
        });
    }
    async checkBufferedAgain() {
        while (!this.loaded) {
            await delay(1000);
            if (this.videoEl.buffered.length > 0) {
                log.debug(`${this.src} ${this.videoEl.buffered.end(0)} ${this.videoEl.duration}`);
                if (this.videoEl.buffered.end(0) === this.videoEl.duration) {
                    return;
                }
            }
            log.debug(`${this.src} readystate ${this.videoEl.readyState}`);
            if (this.videoEl.readyState === 4) {
                return;
            }
        }
    }
}
//# sourceMappingURL=htmlVideoLoader.js.map